/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ConversationLabelFilterConfigColumn =
  (typeof ConversationLabelFilterConfigColumn)[keyof typeof ConversationLabelFilterConfigColumn];

export const ConversationLabelFilterConfigColumn = {
  conversation_label: 'conversation_label',
} as const;
